module.exports = __webpack_public_path__ + "static/media/img-quote-sign.d28e72ef.svg";